const KEEP_ALIVE_TIMEOUT_MS = 30 * 60 * 1000;

const KEEP_ALIVE_APPS = [
  'socialHost',
  'cloudccampaignOverviewQa',
  'socialCalendarQa',
  'socialContentLibraryQa',
  'socialCommentsQa',
  'socialRecommendationsyQa',
  'socialPostsQa2',
  'socialMentionsQa2',
  'socialInsightsQa2',
  'socialSettingsQa',
  'yextAppInt',
];

export { KEEP_ALIVE_APPS, KEEP_ALIVE_TIMEOUT_MS };
